/* 预览 页面 相关接口 */
import http from '@/assets/plugins/axios'
import {backendUrl} from '@/assets/js/config'
let headers = {'Content-type': 'application/x-www-form-urlencoded'}
export default {
  // 1. 获取 预览文件 页面结构
  getFileFormation (params) {
    return http.post(`${backendUrl}/preview/deep/first`, params, headers)
  },
  // 1.1 获取 预览文件 页面结构 （针对分享的计价文件）
  getFileFormationShare (params) {
    return http.post(`${backendUrl}/preview/deep/first_share`, params, headers)
  },
  // 1.2 预览 除了GBQ5 文件的其他文件 获取页面结构
  previewFirst (params, isRecord) {
    if (isRecord) {
      return http.get(`${backendUrl}/projects/recorded/preview/first`, params)
    }
    return http.get(`${backendUrl}/preview/first`, params)
  },
  // 1.3 预览P5\P6工程 备案项目
  getRecordFileFormation (params) {
    return http.post(`${backendUrl}/projects/recorded/preview/deep/first`, params, headers)
  },
  // 2. 深度预览计价文件
  previewDeep (params, isRecord) {
    if (isRecord) {
      return http.post(`${backendUrl}/projects/recorded/preview/deep`, params, headers)
    }
    return http.post(`${backendUrl}/preview/deep`, params, headers)
  },
  // 2.1 深度预览计价文件（针对分享的计价文件）
  previewDeepShare (params) {
    return http.post(`${backendUrl}/preview/deep_share`, params, headers)
  },
  // 2.2 深度预览计量文件
  previewValuation (params, isRecord) {
    if (isRecord) {
      return http.get(`${backendUrl}/projects/recorded/preview/valuation`, params, headers)
    }
    return http.get(`${backendUrl}/preview/valuation`, params, headers)
  },
  // 3. 深度预览计价文件(带子树)
  previewDeepSubTree (params, isRecord) {
    if (isRecord) {
      return http.post(`${backendUrl}/projects/recorded/deep/subtree`, params, headers)
    }
    return http.post(`${backendUrl}/preview/deep/subtree`, params, headers)
  },
  // 3. 深度预览计价文件(带子树 针对分享的计价文件)
  previewDeepSubTreeShare (params) {
    return http.post(`${backendUrl}/preview/deep/subtree_share`, params, headers)
  },
  // 4.  获取所有批注
  updateRemark (query, params) {
    return http.post(`${backendUrl}/preview/comment/update` + query, params)
  }
}

